import React from "react";
import PropTypes from "prop-types";
import Modal from "../modal-new";

function ConfirmRemoveCoach(props, { locals }) {
  const { params, query, editExercise, activeUser } = locals;

  return (
    <form
      action={`/dashboard/settings/manage-coaching`}
      method="POST"
      data-noreset
    >
      <input type="hidden" name="actionToPerform" value="remove" />
      <Modal width="600px" title={"Remove Coach"}>
        <div className="body">
          <div className="columns">
            <div className="column" data-col="1/1">
              By removing your coach they will <b>no longer be able to:</b>
              <ul>
                <li>Send you custom programs</li>
                <li>Access your calendar</li>
                <li>Access your metrics</li>
              </ul>
            </div>
          </div>
        </div>

        <footer className="foot">
          <a
            role="button"
            data-button-type="secondary"
            data-action="cancel"
            href="/actions/refresh?modal="
          >
            Cancel
          </a>
          <button data-button-type="primary" type="submit">
            Remove
          </button>
        </footer>
      </Modal>
    </form>
  );
}

ConfirmRemoveCoach.contextTypes = { locals: PropTypes.object };

export default ConfirmRemoveCoach;
